import router from './router';
import store from './store';
import { Message } from 'element-ui';
import NProgress from 'nprogress'; // progress bar
import 'nprogress/nprogress.css'; // progress bar style
import { isLogged } from '@/admin/js/utils/auth';
import getPageTitle from '@/admin/js/utils/get-page-title';

NProgress.configure({ showSpinner: false }); // NProgress Configuration

const whiteList = ['/login', '/auth-redirect', '/admin-login', '/register', '/widget']; // no redirect whitelist

router.beforeEach(async(to, from, next) => {
  // start progress bar
  NProgress.start();
  // set page title
  document.title = getPageTitle(to.meta.title);

  // determine whether the user has logged in
  const isUserLogged = isLogged();

  if (isUserLogged) {
    if (to.path === '/login' || to.path === '/register') {
      // if is logged in, redirect to the home page
      next({ path: '/' });
      NProgress.done();
    } else {
      // determine whether the user has obtained his permission roles through getInfo
      const hasRoles = store.getters.roles && store.getters.roles.length > 0;
      if (hasRoles) {
        next();
      } else {
        try {
          // get user info
          // note: roles must be a object array! such as: ['admin'] or ,['manager','editor']
          const { roles, permissions } = await store.dispatch('user/getInfo');

          // generate accessible routes map based on roles
          const accessRoutes = await store.dispatch('permission/generateRoutes', { roles, permissions });
          router.addRoutes(accessRoutes);
          next({ ...to, replace: true });
        } catch (error) {
          // remove token and go to login page to re-login
          await store.dispatch('user/resetToken');
          Message.error(error.message || 'Has Error');
          next(`/login?redirect=${to.path}`);
          NProgress.done();
        }
      }
    }
  } else {

    /* has no token*/
    const rootPath = to.matched[0] ? to.matched[0].path : '';

    // Если маршрут помечен как public в meta — пускаем
    if (to.matched.some(r => r.meta && r.meta.public)) {
      next();
      NProgress.done();
      return;
    }

    // Или если путь в whiteList — тоже пускаем
    if (whiteList.includes(rootPath)) {
      next();
      NProgress.done();
      return;
    }

    // Всё остальное — на логин
    next(`/login?redirect=${to.path}`);
    NProgress.done();

  }
});

router.afterEach(() => {
  // finish progress bar
  NProgress.done();
});
